import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';

import { ActionProps } from './types';

export const Actions: React.FC<ActionProps> = React.memo(({ formId, disabled, actionLabel = 'Submit', actionSchema, isLoading }) => {
    return (
        <div className="buttons-row mt-10">
            <Row className="buttons p-0 m-0">
                <Col className="p-0" xs={12} md={12} lg={12}>
                    <div className="form-group d-flex" style={{ justifyContent: actionSchema?.alignItems }}>
                        {actionSchema ? (
                            <>
                                {actionSchema.actions.map(({ type, label, loadingLabel, ...restProps }) => (
                                    <Button key={label} form={formId} type={type} disabled={disabled || isLoading} {...restProps}>
                                        {isLoading ? (loadingLabel || 'Pending ') : label}
                                        {isLoading && <i className="fas fa-spinner fa-spin ml-2" />}
                                    </Button>
                                ))}
                            </>
                        ) : (
                            <Button form={formId} type="submit" disabled={disabled || isLoading}>
                                {isLoading ? 'Pending ' : actionLabel}
                                {isLoading && <i className="fas fa-spinner fa-spin ml-2" />}
                            </Button>
                        )}
                    </div>
                </Col>
            </Row>
        </div>
    );
});
Actions.displayName = 'Actions';
